namespace Areas.Ucop.Detail {
    "use strict";

    export function save() {
        const form = $("#DaUcopForm").dxForm("instance");
        const daucopId = form.option("DaUcopId");
        const newData: any = form.option("formData");

        const result: any = form.validate();

        if (result.isValid) {
            sendRequest(`/UCOP/Detail/Put/${daucopId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function displayPositionLastNameExpression(data: any): string {
        if (data) {
            return (isNotEmpty(data.delegatorPositionLk) ? data.delegatorPositionLk : "") + " "
                + (isNotEmpty(data.lastName) ? data.lastName : "");
        }

        return "Select ...";
    }
}